<template>
  <header v-if="type === StrategyType.sms">
    <div class="card">
      <ContactsIcon class="icon" />

      <div>
        <p class="title">Total de destinatarios:</p>

        <p class="value">{{ data.total_contacts ?? 0 }}</p>
      </div>
    </div>

    <div class="card">
      <SmsIcon class="icon" />

      <div>
        <p class="title">Total de mensajes SMS:</p>

        <p class="value">{{ data.total_messages ?? 0 }}</p>
      </div>
    </div>

    <!-- <div class="card">
      <DolarIcon class="icon" />

      <div>
        <p class="title">Costo por mensaje:</p>

        <p class="value">{{ data.message_price ?? 0 }}</p>
      </div>
    </div> -->

    <div class="card">
      <DolarBagIcon class="icon" />

      <div>
        <p class="title">Costo total:</p>

        <p class="value">{{ data.total_price ?? 0 }}</p>
      </div>
    </div>
  </header>

  <section class="chart">
    <apexcharts
      ref="chart"
      :key="data.strategy_id"
      type="bar"
      width="720"
      :options="options"
      :series="series"
    />

    <a-tooltip
      title="Número de teléfono con tickets abiertos en la plataforma."
      placement="topLeft"
      v-if="hasNotSentState"
    >
      <InfoCircleOutlined class="not-sent-info" />
    </a-tooltip>
  </section>
</template>

<script>
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { StrategyType } from "@/app/shared/utils/enums";

import VueApexCharts from "vue3-apexcharts";
import ContactsIcon from "@/app/shared/components/icons/ContactsIcon.vue";
import SmsIcon from "@/app/shared/components/icons/SmsIcon.vue";
import DolarBagIcon from "@/app/shared/components/icons/DolarBagIcon.vue";

export default {
  components: {
    apexcharts: VueApexCharts,
    ContactsIcon,
    SmsIcon,
    DolarBagIcon,
    InfoCircleOutlined,
  },
  props: {
    data: {
      required: true,
      type: Object,
    },
    type: {
      required: true,
      type: Number,
    },
  },
  setup() {
    return { StrategyType };
  },
  computed: {
    hasNotSentState() {
      return [StrategyType.whatsapp].includes(this.type);
    },
    filteredStates() {
      return this.hasNotSentState
        ? this.data.states
        : this.data.states.filter((s) => s.name !== "No Enviados");
    },
    series() {
      const states = this.filteredStates;
      return [
        {
          name: "Mensajes",
          data: states.map((item) => item.value),
        },
      ];
    },
    options() {
      const states = this.filteredStates;

      const type = this.type;
      return {
        chart: {
          type: "bar",
          height: 400,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 1,
            horizontal: true,
            distributed: true,
            barHeight: "50%",
            dataLabels: {
              position: "top",
            },
          },
        },
        colors:
          type === StrategyType.sms
            ? ["#F0F0F0", "#ADC6FF", "#B7EB8F", "#FFBB96"]
            : ["#F0F0F0", "#ADC6FF", "#FFADD2", "#91D5FF", "#EAFF8F", "#FFBB96"],
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#000"],
            fontSize: "16px",
            fontWeight: "normal",
          },
          textAnchor: "end",
        },
        grid: {
          xaxis: {
            lines: {
              show: true,
            },
          },
        },
        xaxis: {
          categories: states.map((item) => (item.name === "Not_sent" ? "No enviado" : item.name)),

          labels: {
            minHeight: 0,
            maxHeight: 25,
          },
        },
        yaxis: {
          labels: {
            show: true,
            minWidth: 40,
            maxWidth: 120,
          },
        },
      };
    },
  },
};
</script>

<style lang="sass" scoped>
header
  border: 1px solid $gray-5
  border-radius: 8px
  padding: 12px 20px
  display: flex
  justify-content: space-between
  align-items: center
  margin-left: 84px
  // margin-right: 54px

  p
    margin: 0

  .title
    color: $text-tertiary

  .value
    font-size: 20px
    font-weight: 600
    color: $gray-8

.icon
  font-size: 20px
  color: $text-tertiary

.card
  display: flex
  gap: 5px
  align-items: flex-start

.chart
  display: flex
  justify-content: center
  width: 100%
  position: relative

.not-sent-info
  position: absolute
  bottom: calc(50% + 11px)
  left: -10px
</style>
